import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { WebComponentSettingsDto } from '../shared/dto/web-component-settings.dto';

@Component({
  selector: 'wl-public-links-upgrade-dialog',
  templateUrl: './public-links-upgrade-dialog.component.html',
  styleUrl: './public-links-upgrade-dialog.component.less',
    standalone: false
})
export class PublicLinksUpgradeDialogComponent implements OnInit {
  @Output() onUpdateSettings = new EventEmitter<WebComponentSettingsDto>();
  settings: WebComponentSettingsDto;
  showDialog: boolean = false;
  constructor(
  ) {}

  ngOnInit() {
    this.settings = { RedirectLegacyToNew: true } as WebComponentSettingsDto;
  }

  handleUpdateSetings() {
    this.onUpdateSettings.emit(this.settings);
    this.close();
  }
  

  public open() {
    this.showDialog = true;
  }

  public close() {
    this.showDialog = false;
  }
}
